import { formatHours } from "./format-hours";

export class FormatNumbers {
    constructor() {}

    /**
     * O maximo tem de acompanhar o minimo: com maximo 3 e minimo 2, o Intl decidia a
     * quantidade de casas pelo proprio valor -- "R$ 2.697.571,07" num indicador e
     * "R$ 6.501,209" no do lado, na mesma tela. Real tem duas casas.
     */
    static currency(val, decimals) {
        const fractionDigits = decimals > -1 ? decimals : 2;
        const options = {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        };
        const formatNumber = new Intl.NumberFormat("pt-BR", options);
        return formatNumber.format(val);
    }

    static decimals(number, places = 0) {
        const str = Number(number).toFixed(places);
        const dots = str.split(".");
        if (dots.length > 2) {
            const lastDot = str.lastIndexOf(".");
            return (
                str.slice(0, lastDot).replace(".", "") +
                "," +
                str.slice(lastDot + 1)
            );
        }
        const lastDot = str.lastIndexOf(".");
        return lastDot >= 0
            ? str.slice(0, lastDot) + "," + str.slice(lastDot + 1)
            : str;
    }

    static byUnit(unit, value, decimals, negativeParentheses) {
        switch (unit) {
            case "day":
                return this.decimals(value, 0);
            case "int":
                return this.decimals(value, 0);
            case "currency":
                return this.currency(value);
            case "number":
                return this.decimals(value, 2);
            case "hours":
                // `decimals` trata null como 0; aqui também, e undefined/NaN saem vazios
                return formatHours(value === null ? 0 : value);
            case "percentage":
                const formatted = this.decimals(value, decimals) + "%";
                if (negativeParentheses) {
                    return this.formatNegativeNumber({
                        number: value,
                        numberFormatted: formatted
                    });
                }
                return formatted;
            default:
                return value;
        }
    }

    static formatNegativeNumber({ number, numberFormatted }) {
        if (number < 0) {
            return `(${numberFormatted.replace("-", "")})`;
        }
        return numberFormatted;
    }
}
